import { render, staticRenderFns } from "./CreateCoverage.vue?vue&type=template&id=d19f5112&scoped=true&"
import script from "./CreateCoverage.vue?vue&type=script&lang=js&"
export * from "./CreateCoverage.vue?vue&type=script&lang=js&"
import style0 from "./CreateCoverage.vue?vue&type=style&index=0&id=d19f5112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19f5112",
  null
  
)

export default component.exports